import React, { Component } from 'react';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { Panel } from 'primereact/panel';
import PropTypes from 'prop-types';
import HintsHeader from './HintsHeader';
import HintsJPSAddForm from './HintsJPSAddFormContainer';
import HintsNoData from './HintsNoData';
import { HintJPSList } from './HintsList';
import {
  removeSingleJPS,
  getJobProfileSurveys,
  jobProfileInviteJPSMutate,
  jobProfileRemindJPS,
  addRespondentToJPS,
} from '../../../../../services/apps/JobProfileService';
import ArrayUtil from '../../../../../utils/ArrayUtil';
import {
  growlActionSuccess,
  growlErrors,
} from '../../../../../utils/NotificationUtil';
import { withAccount } from '../../../../../components/AccountContext';
import { withGrowl } from '../../../../../components/GrowlNotifications';
import JPSDeleteConfirmModal from './JPSDeleteConfirmModal';
import { intlShape } from '../../../../../components/prop-types';

const messages = defineMessages({
  successNoti: {
    id: 'noti.success',
    defaultMessage: 'Success!',
  },
});

class HintsJPS extends Component {
  static previewJpsURL(assessment) {
    if (assessment) {
      window.open(assessment.startUrl, '_blank');
    } else {
      console.error('null value');
    }
  }

  constructor(props) {
    super(props);
    this.state = {
      isShowAddForm: false,
      selectedJPS: null,
      searching: false,
      JPS: [],
    };

    this.toggleShowAddForm = this.toggleShowAddForm.bind(this);
    this.handleHints = this.handleHints.bind(this);
    this.handleAddJPSRespondent = this.handleAddJPSRespondent.bind(this);
    this.handleInviteJPSRespondent = this.handleInviteJPSRespondent.bind(this);
    this.handleRemindJPSRespondent = this.handleRemindJPSRespondent.bind(this);
    this.handleToggle = this.handleToggle.bind(this);
    this.handleSearchRespondent = this.handleSearchRespondent.bind(this);

    this.deleteSingleJPS = this.deleteSingleJPS.bind(this);
    this.cancelDeleteSingleJPS = this.cancelDeleteSingleJPS.bind(this);
    this.processDeleteSingleJPS = this.processDeleteSingleJPS.bind(this);
  }

  componentDidMount() {
    this.fetchJobJPS();
  }

  async fetchJobJPS() {
    const { match, growl, currentAccount } = this.props;
    const { jobProfileId } = match.params;
    try {
      const data = await getJobProfileSurveys({
        accountId: currentAccount,
        jobProfileId,
      });
      this.setState({
        JPS: data,
      });
    } catch (error) {
      growlErrors(growl, error);
    }
  }

  deleteSingleJPS(asmtId) {
    this.setState({
      selectedJPS: asmtId,
    });
  }

  cancelDeleteSingleJPS() {
    this.setState({
      selectedJPS: null,
    });
  }

  async processDeleteSingleJPS(formValues) {
    const { match, growl } = this.props;
    const { aid } = match.params;
    const { selectedJPS } = this.state;
    const { confirmation_code, re_confirmation_code } = formValues;
    if (selectedJPS && confirmation_code === re_confirmation_code) {
      try {
        await removeSingleJPS({
          jobProfileSurveyId: selectedJPS,
          accountId: aid,
        });
        this.fetchJobJPS();
      } catch (err) {
        growlErrors(growl, err);
      }
      this.setState({
        selectedJPS: null,
      });
    }
  }

  toggleShowAddForm() {
    const { isShowAddForm } = this.state;
    this.setState({ isShowAddForm: !isShowAddForm });
  }

  async handleHints() {
    const {
      onHints, growl, intl, isShowHint,
    } = this.props;
    const { formatMessage } = intl;
    const isShowHintNew = !isShowHint;
    try {
      await onHints(isShowHintNew);
      growlActionSuccess(growl, formatMessage(messages.successNoti));
    } catch (error) {
      growlErrors(growl, error);
    }
  }

  handleAddJPSRespondent(formValues) {
    const { respondent } = formValues;
    if (respondent) {
      this.addExistingRespondentToJPS(respondent.id);
    } else {
      this.addNewRespondentToJPS(formValues);
    }
  }

  async addExistingRespondentToJPS(respondentId) {
    const {
      match, growl, intl: { formatMessage }, currentAccount,
    } = this.props;
    try {
      await addRespondentToJPS({
        accountId: currentAccount,
        jobProfileId: match.params.jobProfileId,
        respondentId,
      });
      growlActionSuccess(growl, formatMessage(messages.successNoti));
      this.toggleShowAddForm();
      this.fetchJobJPS();
    } catch (errors) {
      growlErrors(growl, errors);
      this.toggleShowAddForm();
    }
  }

  async addNewRespondentToJPS(formValues) {
    const {
      match, growl, intl, currentAccount,
    } = this.props;
    const { formatMessage } = intl;
    try {
      await addRespondentToJPS({
        accountId: currentAccount,
        jobProfileId: match.params.jobProfileId,
        respondent: {
          firstName: formValues.firstName,
          lastName: formValues.lastName,
          email: formValues.email,
          locale: formValues.locale,
          gender: formValues.gender,
        },
      });
      growlActionSuccess(growl, formatMessage(messages.successNoti));
      this.toggleShowAddForm();
      this.fetchJobJPS();
    } catch (errors) {
      growlErrors(growl, errors);
      this.toggleShowAddForm();
    }
  }

  async handleInviteJPSRespondent(jpsId) {
    const {
      match, intl, growl,
    } = this.props;
    const { aid } = match.params;
    const { formatMessage } = intl;
    await jobProfileInviteJPSMutate({
      jobProfileSurveyId: jpsId,
      accountId: aid,
    })
      .then((response) => {
        Promise.resolve(response);
        this.fetchJobJPS();
        growlActionSuccess(growl, formatMessage(messages.successNoti));
      })
      .catch((graphqlResponse) => {
        growlErrors(growl, graphqlResponse);
      });
  }

  async handleRemindJPSRespondent(jobProfileSurveyId) {
    const {
      match, intl, growl,
    } = this.props;
    const { aid } = match.params;
    const { formatMessage } = intl;
    await jobProfileRemindJPS({
      jobProfileSurveyId,
      accountId: aid,
    })
      .then((response) => {
        growlActionSuccess(growl, formatMessage(messages.successNoti));
        Promise.resolve(response);
      })
      .catch((graphqlResponse) => {
        growlErrors(growl, graphqlResponse);
      });
  }

  async handleSearchRespondent(searchTerm) {
    const { onSearch } = this.props;
    this.setState({ searching: true });
    await onSearch(searchTerm);
    this.setState({ searching: false });
  }

  async handleToggle(jpsId) {
    const { onHints, onToggle } = this.props;
    await onHints(false);
    await onToggle(jpsId);
    return false;
  }

  render() {
    const {
      preferedLocale, jobId, nameJobProfile,
      match, isShowHint,
    } = this.props;
    const {
      isShowAddForm, searching, JPS, selectedJPS,
    } = this.state;
    const initialValues = {
      locale: preferedLocale,
    };
    return (
      <Panel
        className="panel-JPS"
        header={(
          <HintsHeader
            onShowAddForm={this.toggleShowAddForm}
            onHints={this.handleHints}
            isShow={isShowHint}
            onAdd={this.toggleShowAddForm}
          >
            <label>
              <FormattedMessage id="header.JPS.long" defaultMessage="Job Profile Survey" />
            </label>
          </HintsHeader>
        )}
      >
        {isShowAddForm && (
          <HintsJPSAddForm
            initialValues={initialValues}
            jobProfileSurveys={JPS}
            searching={searching}
            onAdd={this.handleAddJPSRespondent}
            onCancel={this.toggleShowAddForm}
            onSeachRespondent={this.handleSearchRespondent}
          />
        )}

        {ArrayUtil.isEmpty(JPS) && (
          <HintsNoData onAdd={this.toggleShowAddForm}>
            <FormattedMessage id="JPS.empty" defaultMessage="Empty" />
          </HintsNoData>
        )}

        {ArrayUtil.isNotEmpty(JPS) && (
          <HintJPSList
            data={JPS}
            onInvite={this.handleInviteJPSRespondent}
            onToggle={this.handleToggle}
            onRemove={this.deleteSingleJPS}
            specRemove
            previewURL={this.previewJpsURL}
            onReminder={this.handleRemindJPSRespondent}
            jobId={jobId}
            nameJobProfile={nameJobProfile}
          />
        )}

        <JPSDeleteConfirmModal
          isVisible={!!selectedJPS}
          cancelDelete={this.cancelDeleteSingleJPS}
          confirmDelete={this.processDeleteSingleJPS}
          selectedJPS={selectedJPS}
          match={match}
        />
      </Panel>
    );
  }
}

HintsJPS.propTypes = {
  match: PropTypes.objectOf(PropTypes.any).isRequired,
  intl: intlShape.isRequired,
  growl: PropTypes.objectOf(PropTypes.any).isRequired,
  currentAccount: PropTypes.string.isRequired,
  jobId: PropTypes.string.isRequired,
  preferedLocale: PropTypes.string.isRequired,
  nameJobProfile: PropTypes.string.isRequired,
  onHints: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  onToggle: PropTypes.func.isRequired,
  isShowHint: PropTypes.bool.isRequired,
};

export default injectIntl(
  withAccount(
    withGrowl(
      HintsJPS,
    ),
  ),
);
